import { render, staticRenderFns } from "./C-2-1-1__SubCategoryInfo_Tab-Spec.vue?vue&type=template&id=d2edb3b0&"
import script from "./C-2-1-1__SubCategoryInfo_Tab-Spec.vue?vue&type=script&lang=js&"
export * from "./C-2-1-1__SubCategoryInfo_Tab-Spec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports